import { LockFilled } from "@ant-design/icons";
import { Button, Empty, Input, Space } from "antd";
import { FloatingPanel, Result, ResultPage } from "antd-mobile";
import { useEffect, useRef } from "react";

import Chat from "./Chat";

import AIIMG from "src/assets/img/ai.gif";

const anchors = [20, window.innerHeight * 0.4, window.innerHeight * 0.8];

type FloatingPanelRef = {
  setHeight: (
    height: number,
    options?: {
      immediate?: boolean;
    }
  ) => void;
};

export default ({ height }: { height?: number }) => {
  const ref = useRef<FloatingPanelRef>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.setHeight(height || 0);
    }
  }, [height]);

  const quickPicks = [
    "Hello!",
    "Need help",
    "Show me AI stats",
    "Contact support",
    "Restart system",
  ];

  return (
    <>
      <FloatingPanel ref={ref} anchors={anchors}>
        <div style={{ paddingBottom: 130 }}>
          <ResultPage
            icon={<LockFilled style={{ fontSize: "30px" }} />}
            status="success"
            title={<Space>Secured with Fortified Intelligence</Space>}
            description="An AI-powered solution for your business needs."
            children={
              <Empty
                description={false}
                image={AIIMG}
                children={
                  <>
                    <Chat />
                  </>
                }
              />
            }
          />
        </div>
      </FloatingPanel>
    </>
  );
};
